import $ from "jquery";

import {
  bindSearchDropdowns,
} from '../helper_modules/select2_form_helpers';

const searchFormElements = {
  dropdowns: $(`.search-box-field`),
};

export default class GeodisDashboardSearchService {
  constructor() {
    this.searchFormElements = searchFormElements;
    this.bindElements();
  }

  static init() {
    if ($(`.geodis-dashboard.search`).length === 0) {
      return;
    }

    return new GeodisDashboardSearchService();
  }

  bindElements() {
    bindSearchDropdowns(this.searchFormElements);
  }
}
